function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "200",
  height: "200",
  xmlns: "http://www.w3.org/2000/svg",
  style: {
    margin: "auto",
    background: "#fff"
  },
  viewBox: "0 0 100 100",
  preserveAspectRatio: "xMidYMid",
  display: "block"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: "50",
  cy: "50",
  strokeWidth: "4",
  r: "45",
  stroke: "#ef8432",
  fill: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "50",
  cy: "50",
  fill: "none",
  stroke: "#ef8432",
  strokeWidth: "5",
  r: "15",
  strokeDasharray: "47.80972450961724 41.269908169872416"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "rotate",
  repeatCount: "indefinite",
  dur: "1s",
  values: "0 50 50;360 50 50",
  keyTimes: "0;1"
}))));